import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dms',
    templateUrl: './dms.component.html',
})
export class DmsComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
